import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, LARGE_MARGIN } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      position: 'absolute',
      height: 60,
      zIndex: 3,
      top: 30,
      left: 30,
      transition: 'all .3s',
      '& > img': {
        height: '100%',
      },
      [theme.breakpoints.down('sm')]: {
        left: '50%',
        transform: 'translateX(-50%)',
      },
    },
    container: {
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'flex-end',
      position: 'relative',
    },
    imgWrapper: {
      position: 'absolute',
      width: '100vw',
      minHeight: '100vh',
      top: 0,
      left: 0,
      bottom: 0,
    },
    img: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },
    contentWrap: {
      position: 'relative',
      padding: `${MIDDLE_MARGIN}px 0`,
      zIndex: 2,
      width: '800px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: fade(colorsPalette.blueDark, 0.9),
      backdropFilter: 'blur(20px)',
      transition: 'width .3s',
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',
        padding: `130px 0 ${LARGE_MARGIN}px`,
      },
    },
  }),
);

export default useStyles;
